import { useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { GuardProps } from 'types';
import { useEffect } from 'react';
import { history } from 'store';
import { DASHBOARD_PATH } from '../../config';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

const GuestGuard = ({ children }: GuardProps) => {
    const { isLoggedIn, isInitialized, isInitializationError } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const { pathname, search } = history.location;
        if (isLoggedIn && isInitialized) {
            if (pathname === '/') {
                navigate(DASHBOARD_PATH, { replace: true });
            } else {
                const newPathname = pathname + search;
                navigate(newPathname, { replace: true });
            }
        } else if (!isLoggedIn && pathname === '/') {
            navigate('/login', { replace: true });
        } else if (isInitializationError) {
            navigate('/error', { replace: true });
        }
    }, [isInitializationError, isLoggedIn, isInitialized, navigate]);

    return children;
};

export default GuestGuard;
